module.exports = __webpack_public_path__ + "img/ic_add.479e9c1a.svg";